import type { GA4AnalyticsEvent } from '@/domain/shared/types';

export interface PDPClickEventProps {
  element:
    | 'Accordion'
    | 'Read More'
    | 'Element clicked'
    | 'Slider'
    | 'Scroll'
    | 'Clickable text'
    | 'Modal'
    | 'Button'
    | 'Bottom sheet';
  description: string;
  result: string | number | readonly string[] | undefined;
  type?: string;
}

export function createPDPClickEvent({ description, element, type, result }: PDPClickEventProps): GA4AnalyticsEvent {
  return {
    event: 'PDP',
    description,
    element,
    type,
    result: result?.toString().toLowerCase(),
    interaction: true,
  };
}

export interface AccoBasicDetailsEventProps {
  originList: string;
  countryName: string;
  regionName: string;
  cityName: string;
  accoStars: string;
  collections: string;
  brand: string;
  cityId: string;
  countryId: string;
  id: number | null;
  name: string;
  rating: string;
  regionId: string;
}

export interface AccoBasicDetailsEvent {
  event: string;
  ecommerce: {
    detail: {
      actionField: {
        list: string;
      };
      products: [
        {
          accoStars: string;
          badges: string;
          brand: string;
          category: string;
          cityId: string;
          countryId: string;
          id: number | null;
          locationId: string;
          name: string;
          rating: string;
          regionId: string;
        },
      ];
    };
  };
}

export function createAccoBasicDetailsEvent({
  originList,
  countryName,
  regionName,
  cityName,
  accoStars,
  collections,
  brand,
  cityId,
  countryId,
  id,
  name,
  rating,
  regionId,
}: AccoBasicDetailsEventProps): AccoBasicDetailsEvent {
  return {
    event: 'eec.detail',
    ecommerce: {
      detail: {
        actionField: {
          list: originList,
        },
        products: [
          {
            accoStars,
            badges: collections,
            brand,
            category: `${countryName} > ${regionName} > ${cityName}`,
            cityId,
            countryId,
            id,
            locationId: cityId,
            name,
            rating,
            regionId,
          },
        ],
      },
    },
  };
}
